export default "__VITE_ASSET__C3vjbp5H__";